import { chain, each, get } from 'lodash'
import { computed } from '@vue/composition-api'
import useDateFormat from '@/views/composable/useDateFormat'
import useValidation from '@/views/composable/useValidation'
import { TimecardHeaders } from '@/utils/constants/table-headers'

export default timecards => {
  const { isValidDateTimeAttributes } = useValidation()
  const { dateTime } = useDateFormat()

  const hasCheckInData = computed(() => {
    return timecards.value.some(o => o.attributes?.punchedAt || (o.attributes?.declarations || []).length > 0)
  })

  const declarationText = declaration => {
    return declaration.amount == null
      ? declaration.name
      : `${declaration.name} ${Number(declaration.amount).toLocaleString()}円`
  }

  const buildXlsxData = () => {
    return chain(timecards.value)
      .map(o => {
        const data = {}
        each(TimecardHeaders, h => {
          if (h.value === 'actions') return

          if (h.value === 'attributes.breakCards.data') {
            data[h.text] = o.attributes?.breakTimecards?.data?.map(bt => {
              // NOTE: dateTimeにnullが入ると1970-01-01T00:00:00.000Zになるのでnullの場合を考慮
              const startAt = bt.attributes.breakTimeStartAt ? dateTime(bt.attributes.breakTimeStartAt) : null
              const endAt = bt.attributes.breakTimeEndAt ? dateTime(bt.attributes.breakTimeEndAt) : null

              return `${startAt} ~ ${endAt}`
            })?.join(', ')

            return
          }

          if (isValidDateTimeAttributes(h.value)) {
            const dateTimeValue = get(o, h.value)

            data[h.text] = dateTimeValue ? dateTime(dateTimeValue) : null

            return
          }

          data[h.text] = get(o, h.value)
        })

        // 出勤時の申告を使っている店舗だけ、打刻した時刻と申告を足す
        if (hasCheckInData.value) {
          data['打刻した時刻'] = o.attributes?.punchedAt ? dateTime(o.attributes.punchedAt) : null
          data['申告'] = (o.attributes?.declarations || []).map(declarationText).join(', ')
        }

        return data
      })
      .value()
  }

  return {
    buildXlsxData,
    declarationText,
  }
}
